import React from 'react';
import { Route } from 'react-router-dom';
import LMSDashboard from '@/pages/lms/LMSDashboard';
import ContentList from '@/pages/lms/ContentList';
import AssignmentList from '@/pages/lms/AssignmentList';
import SubmissionList from '@/pages/lms/SubmissionList';
import AnnouncementList from '@/pages/lms/AnnouncementList';
import OnlineClassList from '@/pages/lms/OnlineClassList';
import DiscussionForum from '@/pages/lms/DiscussionForum';
import QuizList from '@/pages/lms/QuizList';
import LMSAnalytics from '@/pages/lms/LMSAnalytics';

export const lmsRoutes = (
  <React.Fragment>
    <Route path="lms" element={<LMSDashboard />} />
    <Route path="lms/content" element={<ContentList />} />
    <Route path="lms/content/add" element={<ContentList />} />
    <Route path="lms/assignments" element={<AssignmentList />} />
    <Route path="lms/assignments/add" element={<AssignmentList />} />
    <Route path="lms/submissions" element={<SubmissionList />} />
    <Route path="lms/announcements" element={<AnnouncementList />} />
    <Route path="lms/announcements/add" element={<AnnouncementList />} />
    <Route path="lms/online-classes" element={<OnlineClassList />} />
    <Route path="lms/discussions" element={<DiscussionForum />} />
    <Route path="lms/quizzes" element={<QuizList />} />
    <Route path="lms/analytics" element={<LMSAnalytics />} />
  </React.Fragment>
);
